export const SHOW_STATUS_ONBOARDING_LOCALSTORAGE_KEY = 'show-status-onboarding';
